type IconProps = React.HTMLAttributes<SVGElement>;

export const Icons = {
  logo: (props: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props}>
      <rect width="256" height="256" fill="none" />
      <line
        x1="208"
        y1="128"
        x2="128"
        y2="208"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
      <line
        x1="192"
        y1="40"
        x2="40"
        y2="192"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
    </svg>
  ),
  twitter: (props: IconProps) => (
    <svg
      {...props}
      height="23"
      viewBox="0 0 1200 1227"
      width="23"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
    </svg>
  ),
  gitHub: (props: IconProps) => (
    <svg viewBox="0 0 438.549 438.549" {...props}>
      <path
        fill="currentColor"
        d="M409.132 114.573c-19.608-33.596-46.205-60.194-79.798-79.8-33.598-19.607-70.277-29.408-110.063-29.408-39.781 0-76.472 9.804-110.063 29.408-33.596 19.605-60.192 46.204-79.8 79.8C9.803 148.168 0 184.854 0 224.63c0 47.78 13.94 90.745 41.827 128.906 27.884 38.164 63.906 64.572 108.063 79.227 5.14.954 8.945.283 11.419-1.996 2.475-2.282 3.711-5.14 3.711-8.562 0-.571-.049-5.708-.144-15.417a2549.81 2549.81 0 01-.144-25.406l-6.567 1.136c-4.187.767-9.469 1.092-15.846 1-6.374-.089-12.991-.757-19.842-1.999-6.854-1.231-13.229-4.086-19.13-8.559-5.898-4.473-10.085-10.328-12.56-17.556l-2.855-6.57c-1.903-4.374-4.899-9.233-8.992-14.559-4.093-5.331-8.232-8.945-12.419-10.848l-1.999-1.431c-1.332-.951-2.568-2.098-3.711-3.429-1.142-1.331-1.997-2.663-2.568-3.997-.572-1.335-.098-2.43 1.427-3.289 1.525-.859 4.281-1.276 8.28-1.276l5.708.853c3.807.763 8.516 3.042 14.133 6.851 5.614 3.806 10.229 8.754 13.846 14.842 4.38 7.806 9.657 13.754 15.846 17.847 6.184 4.093 12.419 6.136 18.699 6.136 6.28 0 11.704-.476 16.274-1.423 4.565-.952 8.848-2.383 12.847-4.285 1.713-12.758 6.377-22.559 13.988-29.41-10.848-1.14-20.601-2.857-29.264-5.14-8.658-2.286-17.605-5.996-26.835-11.14-9.235-5.137-16.896-11.516-22.985-19.126-6.09-7.614-11.088-17.61-14.987-29.979-3.901-12.374-5.852-26.648-5.852-42.826 0-23.035 7.52-42.637 22.557-58.817-7.044-17.318-6.379-36.732 1.997-58.24 5.52-1.715 13.706-.428 24.554 3.853 10.85 4.283 18.794 7.952 23.84 10.994 5.046 3.041 9.089 5.618 12.135 7.708 17.705-4.947 35.976-7.421 54.818-7.421s37.117 2.474 54.823 7.421l10.849-6.849c7.419-4.57 16.18-8.758 26.262-12.565 10.088-3.805 17.802-4.853 23.134-3.138 8.562 21.509 9.325 40.922 2.279 58.24 15.036 16.18 22.559 35.787 22.559 58.817 0 16.178-1.958 30.497-5.853 42.966-3.9 12.471-8.941 22.457-15.125 29.979-6.191 7.521-13.901 13.85-23.131 18.986-9.232 5.14-18.182 8.85-26.84 11.136-8.662 2.286-18.415 4.004-29.263 5.146 9.894 8.562 14.842 22.077 14.842 40.539v60.237c0 3.422 1.19 6.279 3.572 8.562 2.379 2.279 6.136 2.95 11.276 1.995 44.163-14.653 80.185-41.062 108.068-79.226 27.88-38.161 41.825-81.126 41.825-128.906-.01-39.771-9.818-76.454-29.414-110.049z"
      ></path>
    </svg>
  ),
  radix: (props: IconProps) => (
    <svg viewBox="0 0 25 25" fill="none" {...props}>
      <path
        d="M12 25C7.58173 25 4 21.4183 4 17C4 12.5817 7.58173 9 12 9V25Z"
        fill="currentcolor"
      ></path>
      <path d="M12 0H4V8H12V0Z" fill="currentcolor"></path>
      <path
        d="M17 8C19.2091 8 21 6.20914 21 4C21 1.79086 19.2091 0 17 0C14.7909 0 13 1.79086 13 4C13 6.20914 14.7909 8 17 8Z"
        fill="currentcolor"
      ></path>
    </svg>
  ),
  aria: (props: IconProps) => (
    <svg role="img" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M13.966 22.624l-1.69-4.281H8.122l3.892-9.144 5.662 13.425zM8.884 1.376H0v21.248zm15.116 0h-8.884L24 22.624Z" />
    </svg>
  ),
  npm: (props: IconProps) => (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M1.763 0C.786 0 0 .786 0 1.763v20.474C0 23.214.786 24 1.763 24h20.474c.977 0 1.763-.786 1.763-1.763V1.763C24 .786 23.214 0 22.237 0zM5.13 5.323l13.837.019-.009 13.836h-3.464l.01-10.382h-3.456L12.04 19.17H5.113z"
        fill="currentColor"
      />
    </svg>
  ),
  yarn: (props: IconProps) => (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M12 0C5.375 0 0 5.375 0 12s5.375 12 12 12 12-5.375 12-12S18.625 0 12 0zm.768 4.105c.183 0 .363.053.525.157.125.083.287.185.755 1.154.31-.088.468-.042.551-.019.204.056.366.19.463.375.477.917.542 2.553.334 3.605-.241 1.232-.755 2.029-1.131 2.576.324.329.778.899 1.117 1.825.278.774.31 1.478.273 2.015a5.51 5.51 0 0 0 .602-.329c.593-.366 1.487-.917 2.553-.931.714-.009 1.269.445 1.353 1.103a1.23 1.23 0 0 1-.945 1.362c-.649.158-.95.278-1.821.843-1.232.797-2.539 1.242-3.012 1.39a1.686 1.686 0 0 1-.704.343c-.737.181-3.266.315-3.466.315h-.046c-.783 0-1.214-.241-1.45-.491-.658.329-1.51.19-2.122-.134a1.078 1.078 0 0 1-.58-1.153 1.243 1.243 0 0 1-.153-.195c-.162-.25-.528-.936-.454-1.946.056-.723.556-1.367.88-1.71a5.522 5.522 0 0 1 .408-2.256c.306-.727.885-1.348 1.32-1.737-.32-.537-.644-1.367-.329-2.21.227-.602.412-.936.82-1.08h-.005c.199-.074.389-.153.486-.259a3.418 3.418 0 0 1 2.298-1.103c.037-.093.079-.185.125-.283.31-.658.639-1.029 1.024-1.168a.94.94 0 0 1 .328-.06zm.006.7c-.507.016-1.001 1.519-1.001 1.519s-1.27-.204-2.266.871c-.199.218-.468.334-.746.44-.079.028-.176.023-.417.672-.371.991.625 2.094.625 2.094s-1.186.839-1.626 1.881c-.486 1.144-.338 2.261-.338 2.261s-.843.732-.899 1.487c-.051.663.139 1.2.343 1.515.227.343.51.176.51.176s-.561.653-.037.931c.477.25 1.283.394 1.71-.037.31-.31.371-1.001.486-1.283.028-.065.12.111.209.199.097.093.264.195.264.195s-.755.324-.445 1.066c.102.246.468.403 1.066.398.222-.005 2.664-.139 3.313-.296.375-.088.505-.283.505-.283s1.566-.431 2.998-1.357c.917-.598 1.293-.76 2.034-.936.612-.148.57-1.098-.241-1.084-.839.009-1.575.44-2.196.825-1.163.718-1.742.672-1.742.672l-.018-.032c-.079-.13.371-1.293-.134-2.678-.547-1.515-1.413-1.881-1.344-1.997.297-.5 1.038-1.297 1.334-2.78.176-.899.13-2.377-.269-3.151-.074-.144-.732.241-.732.241s-.616-1.371-.788-1.483a.271.271 0 0 0-.157-.046z"
        fill="currentColor"
      />
    </svg>
  ),
  pnpm: (props: IconProps) => (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M0 0v7.5h7.5V0zm8.25 0v7.5h7.498V0zm8.25 0v7.5H24V0zM8.25 8.25v7.5h7.498v-7.5zm8.25 0v7.5H24v-7.5zM0 16.5V24h7.5v-7.5zm8.25 0V24h7.498v-7.5zm8.25 0V24H24v-7.5z"
        fill="currentColor"
      />
    </svg>
  ),
  react: (props: IconProps) => (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236zm2.648-10.69c-1.346 0-3.107.96-4.888 2.622-1.78-1.653-3.542-2.602-4.887-2.602-.41 0-.783.093-1.106.278-1.375.793-1.683 3.264-.973 6.365C1.98 8.917 0 10.42 0 12.004c0 1.59 1.99 3.097 5.043 4.03-.704 3.113-.39 5.588.988 6.38.32.187.69.275 1.102.275 1.345 0 3.107-.96 4.888-2.624 1.78 1.654 3.542 2.603 4.887 2.603.41 0 .783-.09 1.106-.275 1.374-.792 1.683-3.263.973-6.365C22.02 15.096 24 13.59 24 12.004c0-1.59-1.99-3.097-5.043-4.032.704-3.11.39-5.587-.988-6.38-.318-.184-.688-.277-1.092-.278zm-.005 1.09v.006c.225 0 .406.044.558.127.666.382.955 1.835.73 3.704-.054.46-.142.945-.25 1.44-.96-.236-2.006-.417-3.107-.534-.66-.905-1.345-1.727-2.035-2.447 1.592-1.48 3.087-2.292 4.105-2.295zm-9.77.02c1.012 0 2.514.808 4.11 2.28-.686.72-1.37 1.537-2.02 2.442-1.107.117-2.154.298-3.113.538-.112-.49-.195-.964-.254-1.42-.23-1.868.054-3.32.714-3.707.19-.09.4-.127.563-.132zm4.882 3.05c.455.468.91.992 1.36 1.564-.44-.02-.89-.034-1.345-.034-.46 0-.915.01-1.36.034.44-.572.895-1.096 1.345-1.565zM12 8.1c.74 0 1.477.034 2.202.093.406.582.802 1.203 1.183 1.86.372.64.71 1.29 1.018 1.946-.308.655-.646 1.31-1.013 1.95-.38.66-.773 1.288-1.18 1.87-.728.063-1.466.098-2.21.098-.74 0-1.477-.035-2.202-.093-.406-.582-.802-1.204-1.183-1.86-.372-.64-.71-1.29-1.018-1.946.303-.657.646-1.313 1.013-1.954.38-.66.773-1.286 1.18-1.868.728-.064 1.466-.098 2.21-.098zm-3.635.254c-.24.377-.48.763-.704 1.16-.225.39-.435.782-.635 1.174-.265-.656-.49-1.31-.676-1.947.64-.15 1.315-.283 2.015-.386zm7.26 0c.695.103 1.365.23 2.006.387-.18.632-.405 1.282-.66 1.933-.2-.39-.41-.783-.64-1.174-.225-.392-.465-.774-.705-1.146zm3.063.675c.484.15.944.317 1.375.498 1.732.74 2.852 1.708 2.852 2.476-.005.768-1.125 1.74-2.857 2.475-.42.18-.88.342-1.355.493-.28-.958-.646-1.956-1.1-2.98.45-1.017.81-2.01 1.085-2.964zm-13.395.004c.278.96.645 1.957 1.1 2.98-.45 1.017-.812 2.01-1.086 2.964-.484-.15-.944-.318-1.37-.5-1.732-.737-2.852-1.706-2.852-2.474 0-.768 1.12-1.742 2.852-2.476.42-.18.88-.342 1.356-.494zm11.678 4.28c.265.657.49 1.312.676 1.948-.64.157-1.316.29-2.016.39.24-.375.48-.762.705-1.158.225-.39.435-.788.636-1.18zm-9.945.02c.2.392.41.783.64 1.175.23.39.465.772.705 1.143-.695-.102-1.365-.23-2.006-.386.18-.63.406-1.282.66-1.933zM17.92 16.32c.112.493.2.968.254 1.423.23 1.868-.054 3.32-.714 3.708-.147.09-.338.128-.563.128-1.012 0-2.514-.807-4.11-2.28.686-.72 1.37-1.536 2.02-2.44 1.107-.118 2.154-.3 3.113-.54zm-11.83.01c.96.234 2.006.415 3.107.532.66.905 1.345 1.727 2.035 2.446-1.595 1.483-3.092 2.295-4.11 2.295-.22-.005-.406-.05-.553-.132-.666-.38-.955-1.834-.73-3.703.054-.46.142-.944.25-1.438zm4.56.64c.44.02.89.034 1.345.034.46 0 .915-.01 1.36-.034-.44.572-.895 1.095-1.345 1.565-.455-.47-.91-.993-1.36-1.565z"
        fill="currentColor"
      />
    </svg>
  ),
  tailwind: (props: IconProps) => (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M12.001,4.8c-3.2,0-5.2,1.6-6,4.8c1.2-1.6,2.6-2.2,4.2-1.8c0.913,0.228,1.565,0.89,2.288,1.624 C13.666,10.618,15.027,12,18.001,12c3.2,0,5.2-1.6,6-4.8c-1.2,1.6-2.6,2.2-4.2,1.8c-0.913-0.228-1.565-0.89-2.288-1.624 C16.337,6.182,14.976,4.8,12.001,4.8z M6.001,12c-3.2,0-5.2,1.6-6,4.8c1.2-1.6,2.6-2.2,4.2-1.8c0.913,0.228,1.565,0.89,2.288,1.624 c1.177,1.194,2.538,2.576,5.512,2.576c3.2,0,5.2-1.6,6-4.8c-1.2,1.6-2.6,2.2-4.2,1.8c-0.913-0.228-1.565-0.89-2.288-1.624 C10.337,13.382,8.976,12,6.001,12z"
        fill="currentColor"
      />
    </svg>
  ),
  google: (props: IconProps) => (
    <svg role="img" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"
      />
    </svg>
  ),
  apple: (props: IconProps) => (
    <svg role="img" viewBox="0 0 24 24" {...props}>
      <path
        d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"
        fill="currentColor"
      />
    </svg>
  ),
  paypal: (props: IconProps) => (
    <svg role="img" viewBox="0 0 24 24" {...props}>
      <path
        d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81 1.01 1.15 1.304 2.42 1.012 4.287-.023.143-.047.288-.077.437-.983 5.05-4.349 6.797-8.647 6.797h-2.19c-.524 0-.968.382-1.05.9l-1.12 7.106zm14.146-14.42a3.35 3.35 0 0 0-.607-.541c-.013.076-.026.175-.041.254-.93 4.778-4.005 7.201-9.138 7.201h-2.19a.563.563 0 0 0-.556.479l-1.187 7.527h-.506l-.24 1.516a.56.56 0 0 0 .554.647h3.882c.46 0 .85-.334.922-.788.06-.26.76-4.852.816-5.09a.932.932 0 0 1 .923-.788h.58c3.76 0 6.705-1.528 7.565-5.946.36-1.847.174-3.388-.777-4.471z"
        fill="currentColor"
      />
    </svg>
  ),
  spinner: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  ),
  arrowCircle: (props: IconProps) => (
    <svg
      {...props}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 29.3333C23.3638 29.3333 29.3333 23.3638 29.3333 16C29.3333 8.6362 23.3638 2.66666 16 2.66666C8.63616 2.66666 2.66663 8.6362 2.66663 16C2.66663 23.3638 8.63616 29.3333 16 29.3333Z"
        stroke="#C7B6FC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 10.6667L10.6666 16L16 21.3333"
        stroke="#5723F5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3333 16H10.6666"
        stroke="#5723F5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  close: (props: IconProps) => (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24 12L12 24"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12L24 24"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  tooltipInfo: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM12 16v-4M12 8h.01"
      ></path>
    </svg>
  ),
  link: (props: IconProps) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3627_868)">
        <path
          d="M6.66602 8.66672C6.95232 9.04948 7.31759 9.36618 7.73705 9.59535C8.15651 9.82452 8.62035 9.9608 9.09712 9.99495C9.57388 10.0291 10.0524 9.9603 10.5002 9.79325C10.9481 9.62619 11.3548 9.36477 11.6927 9.02672L13.6927 7.02672C14.2999 6.39805 14.6359 5.55604 14.6283 4.68205C14.6207 3.80806 14.2701 2.97202 13.6521 2.354C13.0341 1.73597 12.198 1.38541 11.324 1.37781C10.45 1.37022 9.60802 1.7062 8.97935 2.31339L7.83268 3.45339"
          stroke="#5723F5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.33347 7.33332C9.04716 6.95057 8.68189 6.63387 8.26243 6.40469C7.84297 6.17552 7.37913 6.03924 6.90237 6.0051C6.4256 5.97095 5.94707 6.03974 5.49924 6.2068C5.0514 6.37386 4.64472 6.63527 4.3068 6.97332L2.3068 8.97332C1.69961 9.60199 1.36363 10.444 1.37122 11.318C1.37881 12.192 1.72938 13.028 2.3474 13.646C2.96543 14.2641 3.80147 14.6146 4.67546 14.6222C5.54945 14.6298 6.39146 14.2938 7.02013 13.6867L8.16013 12.5467"
          stroke="#5723F5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  notification: (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 17V18C9 18.7956 9.31607 19.5587 9.87868 20.1213C10.4413 20.6839 11.2044 21 12 21C12.7956 21 13.5587 20.6839 14.1213 20.1213C14.6839 19.5587 15 18.7956 15 18V17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 5C10 4.46957 10.2107 3.96086 10.5858 3.58579C10.9609 3.21071 11.4696 3 12 3C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5C15.1484 5.54303 16.1274 6.38833 16.8321 7.4453C17.5367 8.50227 17.9404 9.73107 18 11V14C18.0753 14.6217 18.2954 15.2171 18.6428 15.7381C18.9902 16.2592 19.4551 16.6914 20 17H4C4.54494 16.6914 5.00981 16.2592 5.35719 15.7381C5.70457 15.2171 5.92474 14.6217 6 14V11C6.05956 9.73107 6.4633 8.50227 7.16795 7.4453C7.8726 6.38833 8.85159 5.54303 10 5Z"
        stroke="color-mix(in srgb, currentColor 20%, transparent)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  search: (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2889_14487)">
        <path
          d="M21 21L15 15"
          stroke="color-mix(in srgb, currentColor 20%, transparent)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 10C3 10.9193 3.18106 11.8295 3.53284 12.6788C3.88463 13.5281 4.40024 14.2997 5.05025 14.9497C5.70026 15.5998 6.47194 16.1154 7.32122 16.4672C8.1705 16.8189 9.08075 17 10 17C10.9193 17 11.8295 16.8189 12.6788 16.4672C13.5281 16.1154 14.2997 15.5998 14.9497 14.9497C15.5998 14.2997 16.1154 13.5281 16.4672 12.6788C16.8189 11.8295 17 10.9193 17 10C17 9.08075 16.8189 8.1705 16.4672 7.32122C16.1154 6.47194 15.5998 5.70026 14.9497 5.05025C14.2997 4.40024 13.5281 3.88463 12.6788 3.53284C11.8295 3.18106 10.9193 3 10 3C9.08075 3 8.1705 3.18106 7.32122 3.53284C6.47194 3.88463 5.70026 4.40024 5.05025 5.05025C4.40024 5.70026 3.88463 6.47194 3.53284 7.32122C3.18106 8.1705 3 9.08075 3 10Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  star: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8 1.333l2.06 4.174 4.607.673-3.334 3.247.787 4.586L8 11.847l-4.12 2.166.787-4.586L1.333 6.18l4.607-.673L8 1.333z"
      ></path>
    </svg>
  ),
  startFill: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        fill="#5723F5"
        stroke="#5723F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8 1.333l2.06 4.174 4.607.673-3.334 3.247.787 4.586L8 11.847l-4.12 2.166.787-4.586L1.333 6.18l4.607-.673L8 1.333z"
      ></path>
    </svg>
  ),
  file: (props: IconProps) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.66669 1.33301H4.00002C3.6464 1.33301 3.30726 1.47348 3.05721 1.72353C2.80716 1.97358 2.66669 2.31272 2.66669 2.66634V13.333C2.66669 13.6866 2.80716 14.0258 3.05721 14.2758C3.30726 14.5259 3.6464 14.6663 4.00002 14.6663H12C12.3536 14.6663 12.6928 14.5259 12.9428 14.2758C13.1929 14.0258 13.3334 13.6866 13.3334 13.333V4.99967L9.66669 1.33301Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33331 1.33301V5.33301H13.3333"
        stroke="color-mix(in srgb, currentColor 20%, transparent)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  file2: (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 13C10.4295 13.5741 10.9774 14.0491 11.6066 14.3929C12.2357 14.7367 12.9315 14.9411 13.6467 14.9923C14.3618 15.0435 15.0796 14.9403 15.7513 14.6897C16.4231 14.4392 17.0331 14.047 17.54 13.54L20.54 10.54C21.4508 9.59695 21.9548 8.33394 21.9434 7.02296C21.932 5.71198 21.4061 4.45791 20.4791 3.53087C19.5521 2.60383 18.298 2.07799 16.987 2.0666C15.676 2.0552 14.413 2.55918 13.47 3.46997L11.75 5.17997"
        stroke="#C7B6FC"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.0002 11C13.5707 10.4259 13.0228 9.9508 12.3936 9.60704C11.7645 9.26328 11.0687 9.05886 10.3535 9.00765C9.63841 8.95643 8.92061 9.05961 8.24885 9.3102C7.5771 9.56079 6.96709 9.95291 6.4602 10.46L3.4602 13.46C2.54941 14.403 2.04544 15.666 2.05683 16.977C2.06822 18.288 2.59407 19.542 3.52111 20.4691C4.44815 21.3961 5.70221 21.922 7.01319 21.9334C8.32418 21.9447 9.58719 21.4408 10.5302 20.53L12.2402 18.82"
        stroke="#5723F5"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  bookmark: (props: IconProps) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={props.color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.6668 14L8.00016 11.3333L3.3335 14V3.33333C3.3335 2.97971 3.47397 2.64057 3.72402 2.39052C3.97407 2.14048 4.31321 2 4.66683 2H11.3335C11.6871 2 12.0263 2.14048 12.2763 2.39052C12.5264 2.64057 12.6668 2.97971 12.6668 3.33333V14Z"
        stroke="#0369A1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  dobleChevron: (props: IconProps) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.33333 11.3333L4 7.99996L7.33333 4.66663"
        stroke={props.color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0001 11.3333L8.66675 7.99996L12.0001 4.66663"
        stroke={props.color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  chevron: (props: IconProps) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 12L6 8L10 4"
        stroke={props.color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  chevronDown: (props: IconProps) => (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 7L7 1L1 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  networkX: (props: IconProps) => (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.6009 0H15.0544L9.69434 6.12618L16 14.4625H11.0627L7.19566 9.40657L2.77087 14.4625H0.31595L6.04904 7.90989L0 0H5.06262L8.55811 4.62133L12.6009 0ZM11.7399 12.994H13.0993L4.32392 1.39137H2.86506L11.7399 12.994Z"
        fill="currentColor"
      />
    </svg>
  ),
  networkFacebook: (props: IconProps) => (
    <svg
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.73438 9L9.17188 6.125H6.39062V4.25C6.39062 3.4375 6.76562 2.6875 8.01562 2.6875H9.29688V0.21875C9.29688 0.21875 8.14062 0 7.04688 0C4.76562 0 3.26562 1.40625 3.26562 3.90625V6.125H0.703125V9H3.26562V16H6.39062V9H8.73438Z"
        fill="currentColor"
      />
    </svg>
  ),
  networkYoutube: (props: IconProps) => (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.8566 3.45237C22.8566 3.45237 22.6345 1.88392 21.9502 1.19522C21.0838 0.288809 20.1152 0.284365 19.6708 0.231047C16.4895 -1.27121e-07 11.713 0 11.713 0H11.7042C11.7042 0 6.92771 -1.27121e-07 3.74637 0.231047C3.30205 0.284365 2.33343 0.288809 1.467 1.19522C0.782749 1.88392 0.565031 3.45237 0.565031 3.45237C0.565031 3.45237 0.333984 5.29631 0.333984 7.1358V8.85976C0.333984 10.6992 0.560588 12.5432 0.560588 12.5432C0.560588 12.5432 0.782749 14.1116 1.46256 14.8003C2.32899 15.7067 3.46645 15.6756 3.97297 15.7734C5.79469 15.9467 11.7086 16 11.7086 16C11.7086 16 16.4895 15.9911 19.6708 15.7645C20.1152 15.7112 21.0838 15.7067 21.9502 14.8003C22.6345 14.1116 22.8566 12.5432 22.8566 12.5432C22.8566 12.5432 23.0832 10.7037 23.0832 8.85976V7.1358C23.0832 5.29631 22.8566 3.45237 22.8566 3.45237ZM9.35814 10.9525V4.55873L15.5031 7.76673L9.35814 10.9525Z"
        fill="currentColor"
      />
    </svg>
  ),
  networkTiktok: (props: IconProps) => (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.2149 0H7.51838V10.8985C7.51838 12.1971 6.4813 13.2638 5.19068 13.2638C3.90006 13.2638 2.86296 12.1971 2.86296 10.8985C2.86296 9.6232 3.87702 8.57969 5.12155 8.53333V5.79711C2.37898 5.84347 0.166504 8.09276 0.166504 10.8985C0.166504 13.7276 2.42507 16 5.21374 16C8.00235 16 10.2609 13.7044 10.2609 10.8985V5.31013C11.275 6.05218 12.5195 6.49276 13.8332 6.51596V3.77971C11.8051 3.71015 10.2149 2.04058 10.2149 0Z"
        fill="currentColor"
      />
    </svg>
  ),
  networkInstagram: (props: IconProps) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.00469 1.44091C10.1434 1.44091 10.3967 1.45028 11.2378 1.48779C12.0195 1.52217 12.4417 1.65345 12.7231 1.76284C13.0952 1.90662 13.3641 2.08166 13.6424 2.35984C13.9238 2.64114 14.0958 2.90682 14.2396 3.27877C14.349 3.56007 14.4804 3.98515 14.5148 4.76343C14.5523 5.60735 14.5617 5.86052 14.5617 7.99531C14.5617 10.1332 14.5523 10.3864 14.5148 11.2272C14.4804 12.0086 14.349 12.4306 14.2396 12.7119C14.0958 13.0838 13.9207 13.3526 13.6424 13.6308C13.361 13.9121 13.0952 14.084 12.7231 14.2278C12.4417 14.3372 12.0164 14.4685 11.2378 14.5028C10.3936 14.5403 10.1403 14.5497 8.00469 14.5497C5.86594 14.5497 5.61266 14.5403 4.77155 14.5028C3.98984 14.4685 3.56772 14.3372 3.2863 14.2278C2.91421 14.084 2.6453 13.909 2.36701 13.6308C2.0856 13.3495 1.91362 13.0838 1.76979 12.7119C1.66035 12.4306 1.52902 12.0055 1.49463 11.2272C1.4571 10.3833 1.44772 10.1301 1.44772 7.99531C1.44772 5.85739 1.4571 5.60422 1.49463 4.76343C1.52902 3.98203 1.66035 3.56007 1.76979 3.27877C1.91362 2.90682 2.08872 2.63802 2.36701 2.35984C2.64843 2.07853 2.91421 1.90662 3.2863 1.76284C3.56772 1.65345 3.99296 1.52217 4.77155 1.48779C5.61266 1.45028 5.86594 1.44091 8.00469 1.44091ZM8.00469 0C5.83154 0 5.55951 0.00937683 4.70588 0.0468842C3.85538 0.0843915 3.27067 0.221918 2.76412 0.418832C2.23568 0.625122 1.78855 0.89705 1.34454 1.34401C0.897401 1.78785 0.625366 2.23481 0.418995 2.75991C0.222005 3.26939 0.0844245 3.85075 0.0469025 4.70092C0.0093805 5.55734 0 5.82926 0 8.00156C0 10.1739 0.0093805 10.4458 0.0469025 11.2991C0.0844245 12.1492 0.222005 12.7337 0.418995 13.2401C0.625366 13.7683 0.897401 14.2153 1.34454 14.6591C1.78855 15.103 2.23568 15.378 2.76099 15.5812C3.27067 15.7781 3.85226 15.9156 4.70275 15.9531C5.55638 15.9906 5.82841 16 8.00156 16C10.1747 16 10.4467 15.9906 11.3004 15.9531C12.1509 15.9156 12.7356 15.7781 13.2421 15.5812C13.7674 15.378 14.2146 15.103 14.6586 14.6591C15.1026 14.2153 15.3778 13.7683 15.581 13.2432C15.778 12.7337 15.9156 12.1524 15.9531 11.3022C15.9906 10.4489 16 10.177 16 8.00469C16 5.83239 15.9906 5.56046 15.9531 4.70717C15.9156 3.857 15.778 3.27251 15.581 2.76617C15.384 2.23481 15.112 1.78785 14.6648 1.34401C14.2208 0.900176 13.7737 0.625122 13.2484 0.421957C12.7387 0.225044 12.1571 0.0875171 11.3066 0.0500098C10.4499 0.00937684 10.1778 0 8.00469 0Z"
        fill="currentColor"
      />
      <path
        d="M8.00534 3.89136C5.73526 3.89136 3.89355 5.73234 3.89355 8.00154C3.89355 10.2707 5.73526 12.1117 8.00534 12.1117C10.2754 12.1117 12.1171 10.2707 12.1171 8.00154C12.1171 5.73234 10.2754 3.89136 8.00534 3.89136ZM8.00534 10.6677C6.5326 10.6677 5.33815 9.4737 5.33815 8.00154C5.33815 6.52937 6.5326 5.33539 8.00534 5.33539C9.47808 5.33539 10.6725 6.52937 10.6725 8.00154C10.6725 9.4737 9.47808 10.6677 8.00534 10.6677Z"
        fill="currentColor"
      />
      <path
        d="M13.2385 3.72885C13.2385 4.26021 12.8071 4.68841 12.2789 4.68841C11.7475 4.68841 11.3193 4.25708 11.3193 3.72885C11.3193 3.1975 11.7507 2.76929 12.2789 2.76929C12.8071 2.76929 13.2385 3.20062 13.2385 3.72885Z"
        fill="currentColor"
      />
    </svg>
  ),
  arrow: (props: IconProps) => (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.5 12.6667V3.33337"
        stroke={props.color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.83398 8.00004L8.50065 3.33337L13.1673 8.00004"
        stroke={props.color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  warning: (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.7301 18.0002L13.7301 4.00022C13.5556 3.69243 13.3027 3.43641 12.997 3.25829C12.6913 3.08017 12.3438 2.98633 11.9901 2.98633C11.6363 2.98633 11.2888 3.08017 10.9831 3.25829C10.6774 3.43641 10.4245 3.69243 10.2501 4.00022L2.25005 18.0002C2.07373 18.3056 1.98128 18.6521 1.98206 19.0047C1.98284 19.3573 2.07683 19.7035 2.2545 20.008C2.43217 20.3126 2.6872 20.5648 2.99375 20.7391C3.30029 20.9133 3.64746 21.0034 4.00005 21.0002H20.0001C20.351 20.9999 20.6956 20.9072 20.9993 20.7315C21.3031 20.5558 21.5553 20.3033 21.7306 19.9993C21.9059 19.6954 21.9981 19.3506 21.998 18.9997C21.9979 18.6488 21.9055 18.3041 21.7301 18.0002Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9V13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17H12.01"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  pdf: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        clipPath="url(#clip0_4085_54046)"
      >
        <path stroke="#C7B6FC" d="M14 3v4a1 1 0 001 1h4"></path>
        <path stroke="#C7B6FC" d="M5 12V5a2 2 0 012-2h7l5 5v4"></path>
        <path
          stroke="#5723F5"
          d="M5 18h1.5a1.5 1.5 0 100-3H5v6M17 18h2M20 15h-3v6M11 15v6h1a2 2 0 002-2v-2a2 2 0 00-2-2h-1z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4085_54046">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
  linkNormative: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        stroke="#C7B6FC"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"
      ></path>
      <path
        stroke="#5723F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"
      ></path>
    </svg>
  ),
  document3: (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.5 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V7.5L14.5 2Z"
        stroke="#C7B6FC"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 2V8H20"
        stroke="#5723F5"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  documentPdf: (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_4085_54232)">
        <path
          d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19"
          stroke="#C7B6FC"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 12V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V12"
          stroke="#C7B6FC"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 18H6.5C6.89782 18 7.27936 17.842 7.56066 17.5607C7.84196 17.2794 8 16.8978 8 16.5C8 16.1022 7.84196 15.7206 7.56066 15.4393C7.27936 15.158 6.89782 15 6.5 15H5V21"
          stroke="#5723F5"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17 18H19"
          stroke="#5723F5"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20 15H17V21"
          stroke="#5723F5"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 15V21H12C12.5304 21 13.0391 20.7893 13.4142 20.4142C13.7893 20.0391 14 19.5304 14 19V17C14 16.4696 13.7893 15.9609 13.4142 15.5858C13.0391 15.2107 12.5304 15 12 15H11Z"
          stroke="#5723F5"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4085_54232">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  document: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        stroke="#C7B6FC"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M14.5 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V7.5L14.5 2z"
      ></path>
      <path
        stroke="#C7B6FC"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M14 2v6h6"
      ></path>
      <path
        stroke="#5723F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 18v-4M8 18v-2M16 18v-6"
      ></path>
    </svg>
  ),
  like: (props: IconProps) => (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.08333 13.4167V26.0833C8.08333 26.5033 7.91652 26.906 7.61959 27.2029C7.32265 27.4999 6.91993 27.6667 6.5 27.6667H3.33333C2.91341 27.6667 2.51068 27.4999 2.21375 27.2029C1.91681 26.906 1.75 26.5033 1.75 26.0833V15C1.75 14.5801 1.91681 14.1774 2.21375 13.8804C2.51068 13.5835 2.91341 13.4167 3.33333 13.4167H8.08333ZM8.08333 13.4167C9.76304 13.4167 11.3739 12.7494 12.5617 11.5617C13.7494 10.374 14.4167 8.76305 14.4167 7.08334V5.50001C14.4167 4.66016 14.7503 3.8547 15.3442 3.26084C15.938 2.66697 16.7435 2.33334 17.5833 2.33334C18.4232 2.33334 19.2286 2.66697 19.8225 3.26084C20.4164 3.8547 20.75 4.66016 20.75 5.50001V13.4167H25.5C26.3399 13.4167 27.1453 13.7503 27.7392 14.3442C28.333 14.938 28.6667 15.7435 28.6667 16.5833L27.0833 24.5C26.8556 25.4713 26.4237 26.3054 25.8525 26.8765C25.2814 27.4477 24.602 27.725 23.9167 27.6667H12.8333C11.5736 27.6667 10.3654 27.1662 9.47458 26.2754C8.58378 25.3846 8.08333 24.1765 8.08333 22.9167"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  document2: (props: IconProps) => (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.7501 3.16666H14.2501C13.3756 3.16666 12.6667 3.87554 12.6667 4.74999V7.91666C12.6667 8.79111 13.3756 9.49999 14.2501 9.49999H23.7501C24.6245 9.49999 25.3334 8.79111 25.3334 7.91666V4.74999C25.3334 3.87554 24.6245 3.16666 23.7501 3.16666Z"
        stroke="#5723F5"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.3333 6.33334H28.4999C29.3398 6.33334 30.1452 6.66697 30.7391 7.26084C31.333 7.8547 31.6666 8.66016 31.6666 9.50001V31.6667C31.6666 32.5065 31.333 33.312 30.7391 33.9058C30.1452 34.4997 29.3398 34.8333 28.4999 34.8333H9.49992C8.66007 34.8333 7.85461 34.4997 7.26075 33.9058C6.66688 33.312 6.33325 32.5065 6.33325 31.6667V9.50001C6.33325 8.66016 6.66688 7.8547 7.26075 7.26084C7.85461 6.66697 8.66007 6.33334 9.49992 6.33334H12.6666"
        stroke="#5723F5"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19 17.4167H25.3333"
        stroke="#5723F5"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19 25.3333H25.3333"
        stroke="#5723F5"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.6667 17.4167H12.6826"
        stroke="#5723F5"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.6667 25.3333H12.6826"
        stroke="#5723F5"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  dollar: (props: IconProps) => (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19 3.16666V34.8333"
        stroke="#5723F5"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M26.9167 7.91666H15.0417C13.5719 7.91666 12.1624 8.50051 11.1231 9.53977C10.0839 10.579 9.5 11.9886 9.5 13.4583C9.5 14.9281 10.0839 16.3376 11.1231 17.3769C12.1624 18.4161 13.5719 19 15.0417 19H22.9583C24.4281 19 25.8376 19.5838 26.8769 20.6231C27.9161 21.6624 28.5 23.0719 28.5 24.5417C28.5 26.0114 27.9161 27.4209 26.8769 28.4602C25.8376 29.4995 24.4281 30.0833 22.9583 30.0833H9.5"
        stroke="#5723F5"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  dappiLogo: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="30"
      fill="none"
      viewBox="0 0 38 30"
      {...props}
    >
      <path
        fill="#fff"
        d="M28.43 3.42a9.23 9.23 0 00-1.776.172C24.898 1.394 22.224 0 19.239 0c-2.983 0-5.548 1.343-7.304 3.46a9.542 9.542 0 00-2.365-.305C4.29 3.155 0 7.53 0 12.914c0 4.722 3.313 8.67 7.684 9.566 0 .03 4.111.366 4.111.366h7.345V30c3.512-.865 6.646-3.674 7.524-7.235a9.132 9.132 0 001.766.162c5.279 0 9.57-4.375 9.57-9.759 0-5.383-4.291-9.759-9.57-9.759v.01zm0 17.289a7.06 7.06 0 01-1.477-.153 6.873 6.873 0 01-2.265-.895 7.774 7.774 0 01-.17 2.422 7.649 7.649 0 01-3.023 4.538v-4.986c0-.336-.13-.63-.35-.855a1.15 1.15 0 00-.738-.346H10.219c-.19 0-.55.04-.55 0h-.12a7.226 7.226 0 01-2.105-.315c-3.043-.926-5.269-3.806-5.269-7.205 0-4.152 3.313-7.53 7.375-7.53.36 0 .718.03 1.068.08a6.93 6.93 0 012.125.672 7.438 7.438 0 011.357-1.8 7.224 7.224 0 015.11-2.107 7.28 7.28 0 015.129 2.116 7.45 7.45 0 011.367 1.832 7.213 7.213 0 012.704-.53c4.072 0 7.385 3.38 7.385 7.521 0 4.142-3.313 7.53-7.385 7.53l.02.011z"
      ></path>
      <path
        fill="#fff"
        d="M25.686 10.96c-.569-3.42-3.642-5.8-7.025-5.434-1.387.152-1.407 2.391 0 2.239 2.494-.275 4.49 1.261 4.91 3.785.239 1.415 2.345.814 2.115-.59zM16.585 9.963c-2.205-2.667-5.987-3.145-8.762-1.11-1.137.835-.04 2.779 1.108 1.934 2.036-1.496 4.48-1.211 6.107.753.908 1.1 2.455-.488 1.547-1.577zM5.858 14.725c1.437 2.382 4.22 3.715 6.785 2.351 1.258-.662.15-2.595-1.107-1.934-1.477.784-3.014-.264-3.782-1.546-.769-1.283-2.635-.102-1.896 1.13zM18.88 18.918c2.415-.356 4.65-2.371 4.42-5.017-.089-1.069-1.736-1.079-1.646 0 .17 1.964-1.477 3.145-3.213 3.399-1.048.152-.599 1.77.44 1.618z"
      ></path>
      <path
        fill="#fff"
        d="M22.413 17.249c2.784 1.2 5.828.112 7.215-2.666.479-.957-.938-1.812-1.417-.845-.928 1.873-2.974 2.92-4.96 2.066-.968-.417-1.806 1.028-.828 1.445h-.01z"
      ></path>
      <path
        fill="#fff"
        d="M27.672 11.041c-.33 2.361 1.087 4.498 3.413 4.987 1.037.213 1.477-1.394.439-1.618-1.348-.285-2.475-1.435-2.265-2.931.15-1.058-1.438-1.516-1.587-.448v.01zM13.581 1.893C11.256 3.54 9.76 6.574 11.336 9.29c.719 1.242 2.615.112 1.896-1.13-.928-1.607.11-3.388 1.457-4.335 1.148-.814.06-2.757-1.108-1.933zM30.416 3.643c-3.453-.977-6.806.896-7.983 4.315-.47 1.364 1.646 1.944 2.115.59.779-2.28 3.034-3.389 5.29-2.758 1.366.387 1.945-1.77.578-2.157v.01z"
      ></path>
    </svg>
  ),
};
